<template>
    <div class="w-100 px-4 ">
        <div class="d-flex">
            <agregar-cliente-extra-costo-modal />

            <editar-cliente-extra-costo-modal 
                :ids="ids"
            />

            <editar-multiple-cliente-extra-costo-modal
                :ids="checks"
            />

            <Button
                :size="15"
                color="#E15361"
                colorText="#ffffff"
                tooltip="Eliminar Tarifa Clientes Seleccionados"
                icon="far fa-trash-alt"
                round
                :width="30"
                class="mr-2"
                traslate
                @click.native="deleteChecks"
                :inactive="checks.length < 1"
            />

            <filtros-clientes-extra-costos-modal />

            <Button 
                class="mr-2" 
                color="#E15361" 
                colorText="#fff" 
                icon="fas fa-filter" 
                :width="30" 
                tooltip="Recargar Tabla" 
                round 
                @click.native="fetch"    
            />

            <Button 
                color="#4FB36A" 
                colorText="#fff" 
                icon="fas fa-file-excel" 
                :width="30" 
                tooltip="Generar Reporte Excel" 
                round
                @click.native="actionSetShowBtnExporterClienteExtraCostoModal(true); actionSetShowModalFilterClienteExtraCostoModal(true)"
            />
        </div>
        <div class="w-100 text-center">
            <loading v-if="showLoadingClienteExtraCosto"/>
            <new-data-table
                v-else
                :headers="headers"
                :data="data"
                :acciones="acciones"
                :max="10"
                paginacion
                buscar
                numerador
                :seleccionar="obtenerFilaSeleccionada"
                :filaChekeada="obtenerFilaSeleccionada"
                check
                idtabla="listado_clientes_extra_cost_tabla"
            />
        </div>
        
    </div>
    
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { tariffClientsExtraCostoDelete, tariffClientsExtraCostoIndex, tariffClientsExtraCostoInit } from '../../../constants/serviciosLogisticos';
import Loading from '../../common/loading.vue';
import NewDataTable from '../../common/NewDataTable';
import AgregarClienteExtraCostoModal from '../../modals/tarifas/clientesExtraCostos/AgregarClienteExtraCostoModal.vue';
import EditarClienteExtraCostoModal from '../../modals/tarifas/clientesExtraCostos/EditarClienteExtraCostoModal.vue';
import EditarMultipleClienteExtraCostoModal from '../../modals/tarifas/clientesExtraCostos/EditarMultipleClienteExtraCostoModal.vue';
import Button from '../../common/Button.vue';
import FiltrosClientesExtraCostosModal from '../../modals/tarifas/clientesExtraCostos/FiltrosClientesExtraCostosModal.vue';

export default {
    data() {
        return {
            acciones: [] ,
            data: [] ,
            ids: [],
            checks: [],
            headers: [
                "ID",
                "Cliente",
                "Desde",
                "Hasta",
                "Proveedor",
                "Tipo Extra Costo",
                "Tipo Contenedor",
                "Moneda",
                "Valor",
                "Observaciones",
                "ID Tarifa Proveedor",
                "Acciones",
            ] ,
        };
    },
    props: {},

    components: {
        NewDataTable,
        AgregarClienteExtraCostoModal,
        EditarClienteExtraCostoModal,
        Loading,
        Button,
        EditarMultipleClienteExtraCostoModal,
        FiltrosClientesExtraCostosModal,
    },

    created() {},

    mounted() {
        this.init();
        this.fetch() ;
    },

    methods: {
        
        ...mapActions("serviciosLogisticos", [
            "actionSetListCarriers",
            "actionSetListCurrencies",
            "actionSetExtraCostTypes",
            "actionSetUnityPayments",
            "actionSetContainerTypes",
            "actionSetClientsList",
            "actionSetDocumentariesServicesTypeList",
            "actionSetDataTableClienteExtraCosto",
            "actionSetShowLoadingClienteExtraCosto",
            "actionSetShowModalEditClienteExtraCostoModal",
            "actionSetShowBtnExporterClienteExtraCostoModal",
            "actionSetShowModalFilterClienteExtraCostoModal", 
        ]),

        async init(){

            const { data } = await tariffClientsExtraCostoInit() ;

            this.actionSetListCarriers( data.carriers );
            this.actionSetListCurrencies( data.currencies );
            this.actionSetExtraCostTypes( data.extraCostTypes );
            this.actionSetUnityPayments( data.unityPayments );
            this.actionSetContainerTypes( data.containerTypes );
            this.actionSetClientsList( data.clients );
            this.actionSetDocumentariesServicesTypeList( data.servicesTypes );
        },

        async fetch(){
            
            this.actionSetShowLoadingClienteExtraCosto( true );

            const { data } = await tariffClientsExtraCostoIndex() ;

            this.actionSetDataTableClienteExtraCosto( data ) ;

            this.actionSetShowLoadingClienteExtraCosto( false );
        },

        async obtenerFilaSeleccionada( { id , accion , estado } ) {

            const idd = +this.data[ id ].data_complementaria.id ;

            switch (accion) {

                case "Editar": {

                    this.actionSetShowModalEditClienteExtraCostoModal( true );

                    this.ids = [ idd ];
                }
                break;

                case "Eliminar": {

                    const response = await this.$vToastify.prompt(`¿Desea eliminar Registro?`) ;

                    if( ! response ) return ;

                    this.$vToastify.loader("Eliminando...");

                    try {

                        const payload = { ids : [ idd ] } ;

                        await tariffClientsExtraCostoDelete( payload ) ;

                        this.$vToastify.stopLoader();

                        this.$vToastify.success("Se ha eliminado Registro", "Éxito");

                        return this.fetch();

                    } catch (error) {

                        this.$vToastify.stopLoader();                        
                        this.$vToastify.error("Hubo un problema al intentar eliminar. Favor, recargue la página y vuelva a intentar.", "Error");
                    }

                }
                break;
                case "fila_chekeada":{
                    estado 
                        ? this.checks.push( idd )
                        : this.checks = this.checks.filter( c => c != idd ) ;
                }

                break;
                default:
                    break;
            }
        },
        async deleteChecks(){

            const response = await this.$vToastify.prompt(`¿Desea eliminar ${ this.checks.length } Registros?`) ;

            if( ! response ) return ;

            this.$vToastify.loader("Eliminando...");

            try {
                
                const payload = {
                    ids : this.checks
                };

                await tariffClientsExtraCostoDelete( payload ) ;

                this.$vToastify.stopLoader();

                this.$vToastify.success("Se han eliminado Registro(s)", "Éxito");

                return this.fetch();

            } catch (error) {
                this.$vToastify.stopLoader();                        
                this.$vToastify.error("Hubo un problema al intentar eliminar. Favor, recargue la página y vuelva a intentar.", "Error");
            }

        },
        async generarBotonesAcciones() {

            this.acciones = [];

            await this.data.map((item, index) => {

                this.acciones.push([
                {
                    icon: "fa fa-edit zoom ",
                    title: "Editar",
                    id: index,
                },
                {
                    icon: "fa fa-times text-danger zoom",
                    title: "Eliminar",
                    id: index,
                },
                ]);
            });

        },
    },

    computed: {
        ...mapState("serviciosLogisticos", [
            "dataTableClienteExtraCosto",
            'showLoadingClienteExtraCosto'
        ]),
    },

    watch: {
        dataTableClienteExtraCosto : function( _new ) {


            if( _new ){

                this.checks = [];

                this.data = _new.map( n => ({
                    data: [
                        n.id ,
                        n.name_client ,
                        n.from ,
                        n.to   ,
                        n.name_carrier ,
                        n.name_extra_costos_tipos ,
                        n.name_type_container     ,
                        n.code_currency ,
                        n.value ,
                        n.comment,
                        n.id_tariff_provider_extra_cost
                    ],
                    data_complementaria : n
                })) ;

                this.generarBotonesAcciones() ;
            }
            
        }
    }
};
</script>

<style >

</style>
